module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-trial-bg.dafbbd4b.png";